import React, { useEffect, useState } from 'react';

import { Post } from '@lib/wordpress.d';
import { FAQItem, FAQsView } from '@modules/shared/FAQs/FAQsView';
import { FAQIds } from '@util/constants';

import { domParser, extractIdFromHtml } from '../extractIdFromHtml';

type Props = {
  post: Post;
};

export const FAQsConnector = (props: Props) => {
  const { post } = props;

  const questions = extractIdFromHtml(post.content.rendered, FAQIds.QUESTION);
  const [faqItems, setFAQItems] = useState<FAQItem[]>();

  useEffect(() => {
    const elements = domParser(post.content.rendered, FAQIds.ANSWER);
    let list: FAQItem[] = [];
    if (elements) {
      questions?.map((question, index) => {
        list?.push({
          title: question?.content ?? '',
          details: elements?.[index]?.innerHTML ?? '',
        });
      });
      setFAQItems(list);
    }
  }, []);

  if (!faqItems || faqItems.length === 0) {
    return null;
  }

  return <FAQsView faqItems={faqItems} isBackgroundColorRequired={true} />;
};
